module.exports = __webpack_public_path__ + "img/montserrat-v15-latin-500italic.9a6a1583.svg";